import {strip} from '@/common/questionsExporter/utility'

const multipleChoiceQuestion = (question, stripValues = false) => {
    const strippedPrompt = strip(question.question)

    const options = question.possible_answers ? question.possible_answers : []
    const optionMapper = (option) => {
        const value = stripValues ? strip(option.value, false) : option.value

        return `${option.option}: ${value}`
    }
    const formattedOptions = options.map(optionMapper).join("\n")

    return `${strippedPrompt}\n${formattedOptions}`
}

export {multipleChoiceQuestion}
